/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationOptionsForSkuDetails extends models.RecommendationOptionsBase {
    constructor() {
        super();
        this.setDiscriminator("RecommendationOptionsForSkuDetails");
    }

    getFixupPrototypeFunction() { return RecommendationOptionsForSkuDetails.fixupPrototype; }

    static newInstance(model: Partial<RecommendationOptionsForSkuDetails>): RecommendationOptionsForSkuDetails {
        let obj = Object.assign(new RecommendationOptionsForSkuDetails(), model);
        RecommendationOptionsForSkuDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationOptionsForSkuDetails>): RecommendationOptionsForSkuDetails {
        if (!model) return null;
        return RecommendationOptionsForSkuDetails.newInstance(<RecommendationOptionsForSkuDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationOptionsForSkuDetails) {
        if (!obj) return;

        models.RecommendationOptionsForSkuDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationOptionsForSkuDetails): boolean {
        if (models.RecommendationOptionsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationOptionsForSkuDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.safety_score === undefined) {
            this.safety_score = 0;
        }
        if (this.additional_sku_details) {
            models.RecommendationSkuDetailsBase.fixupPrototype(this.additional_sku_details);
        }
    }

    additional_sku_details: models.RecommendationSkuDetailsBase;

    /**
     * recommended sku for the resource
     */
    recommended_sku: string;

    /**
     * optimization finding
     */
    optimization_finding: string;

    /**
     * safety score
     */
    safety_score: number;

}
